export default "__VITE_ASSET__DzhkRX3R__"